import React from 'react';
import { getFormattedPriceTag } from '../../libs/utils/numberUtils';

const ItemContentList = ({ transaction }) => {
  return (
    <div className="item-content-list">
      {transaction.itemDetails.map(item => (
        <div key={item.id} className="item-content-info">
          <img className="item-content-image" src={item.image} alt="item image"/>
          <div className="item-content-info-row">
            <div className="item-content-detail">
              <div>{item.quantity}</div>
              <div className="item-multiplication">&times;</div>
              <div>{item.name}</div>
            </div>
            <div>{getFormattedPriceTag(item.price)}</div>
          </div>
        </div>
      ))}
      <div className="item-content-divider"/>
      <div className="item-content-subtotal">
        <span className="item-content-subtotal-text">Subtotal</span>
        <span>{getFormattedPriceTag(transaction.grossAmount)}</span>
      </div>
    </div>
  );
};

export default ItemContentList;
